import React from 'react';
import { CnLayoutRow as UICnLayoutRow } from '@cainiaofe/cn-ui';
const CnLayoutRow = (props) => {
    const { children } = props || {};
    return <UICnLayoutRow>{children}</UICnLayoutRow>;
};
CnLayoutRow.displayName = 'CnLayoutRow';
export default CnLayoutRow;
export { CnLayoutRow };
